// extracted by mini-css-extract-plugin
module.exports = {"wrap":"xg","title":"yg"};